export const getPreviewImageUrl = (uniqueId, thumbSize = 300) => {
  return thumbSize
    ? `/api/thumb/${uniqueId}/${thumbSize}`
    : `/api/thumb/${uniqueId}`; // original
};
